module.exports = __webpack_public_path__ + "img/renew-contract-bg.2875f64f.svg";